// Format phone string to numbers [(5xxx) - xxx - xx - xx] to [5xxxxxxxxxx]
export const formatPhoneStringToNumber = phoneString => {
  return phoneString.replace(/[^0-9]/g, '');
};

// This function does not work with nested array
// i.e arrayData = [{id: "1", name: "bilyoner"}, ...];
export const convertDataForSelect = (arrayData, key, value) => {

  const dataForSelect = [];

  for (let data of arrayData) {

    let optionData = {
      key: data[key],
      value: data[value]
    };

    dataForSelect.push(optionData);
  }

  return dataForSelect;
};

//This function converts an array to an object with identified object
export function normalizeArray (array, id = 'id') {
  return array.reduce((acc, item) => {
    return Object.assign(acc, { [item[id]]: item });
  }, {});
}

//Removes wanted key from object, assigns it's value directly to main object
export function removeNestedKeyFromObject (o, k) {
  return Object.entries(o).reduce((acc, entry) => {
    const key = entry[0];
    let value = entry[1];
    if (value === null || value === undefined) {
      return Object.assign(acc, { [key]: value });
    }
    // This is a while block in order to remove nested K's
    while (value[k] !== undefined) {
      value = value[k];
    }
    if (value instanceof Array) {
      value = value.map(item => {
        if (item instanceof Object || item instanceof Array) {
          return removeNestedKeyFromObject(item, k);
        } else {
          return item;
        }
      });
    } else if (value instanceof Object) {
      value = removeNestedKeyFromObject(value, k);
    }
    return Object.assign(acc, { [key]: value });
  }, {});
}

//Converts each words to title case format
export const toTitleCase = str => {
  return str.replace(
    /\w\S*/g,
    txt => {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    }
  );
};

export const dotConverter = (data, type) => {
  data = data?.toString();
  if (data) {
    let convertedOdd;
    let splitedOdd = data.split('.');

    if (!!splitedOdd[1] && splitedOdd[1].length === 2 ) {

      convertedOdd = data;
    } else if (splitedOdd[1] === undefined) {

      convertedOdd = splitedOdd[0] + '.00';
    } else if (splitedOdd[1].length === 1) {
      if (type === 'H' || type === 'T') {
        convertedOdd = splitedOdd[0] + (splitedOdd[1] === '0' ? '' : (',' + splitedOdd[1]));
      } else {
        convertedOdd = splitedOdd[0] + '.' + splitedOdd[1] + '0';
      }
    }

    return convertedOdd;
  } else {
    return data;
  }
};

export const objectFlip = obj => {
  const ret = {};
  Object.keys(obj).forEach(key => {
    ret[obj[key]] = key;
  });
  return ret;
};
